import React, { useState, useEffect } from 'react';
import './index.css'; // Make sure this imports Tailwind CSS and your custom styles
import background from './images/Erewhon.webp';
import grayHoodieImage from './images/grayhoodie.png';
import blackHoodieImage from './images/blackhoodie.webp';

function App() {
  const [selectedColor, setSelectedColor] = useState('gray');
  const [selectedSize, setSelectedSize] = useState('');
  const [buyLink, setBuyLink] = useState(''); // Define buyLink and setBuyLink

  // Object containing all the links for each variant
  const links = {
    gray: {
      S: 'https://square.link/u/McPDo85E',
      M: 'https://square.link/u/oZZutSHd',
      L: 'https://square.link/u/B4zUrj9v',
      XL: 'https://square.link/u/kwUvjR5J'
    },
    black: {
      S: 'https://square.link/u/yte640GD',
      M: 'https://square.link/u/Wu4mLXlV',
      L: 'https://square.link/u/kgsVlZKM',
      XL: 'https://square.link/u/2ZSKirgf'
    }
  };

  useEffect(() => {
    // Update the buy link whenever the color or size changes
    if (selectedSize && selectedColor) {
      setBuyLink(links[selectedColor][selectedSize]);
    }
  }, [selectedColor, selectedSize]);

  const handleColorSelect = (color) => setSelectedColor(color);
  const handleSizeSelect = (size) => setSelectedSize(size);

  const hoodieImage = selectedColor === 'gray' ? grayHoodieImage : blackHoodieImage;
  const sizes = ['S', 'M', 'L', 'XL'];

  return (
    <div style={{
      backgroundImage: `url(${background})`,
      minHeight: '100vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px'
    }}>
      <div className="boxed">
        <img src={hoodieImage} alt={`${selectedColor} Hoodie`} style={{ width: '100%', maxWidth: '500px', height: 'auto' }} />
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', margin: '20px 0' }}>
          <div
            onClick={() => handleColorSelect('gray')}
            style={{
              width: '60px', height: '30px', backgroundColor: '#cccccc',
              border: selectedColor === 'gray' ? '2px solid #e87c24' : 'none',
              cursor: 'pointer'
            }}
          ></div>
          <div
            onClick={() => handleColorSelect('black')}
            style={{
              width: '60px', height: '30px', backgroundColor: 'black',
              border: selectedColor === 'black' ? '2px solid #e87c24' : 'none',
              cursor: 'pointer'
            }}
          ></div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', margin: '20px 0' }}>
          {sizes.map((size) => (
            <div
              key={size}
              onClick={() => handleSizeSelect(size)}
              style={{
                width: '40px', height: '30px',
                backgroundColor: '#ffffff',
                color: 'black',
                lineHeight: '30px',
                textAlign: 'center',
                cursor: 'pointer',
                boxShadow: selectedSize === size ? '0 0 0 2px #e87c24 inset' : 'none',
              }}
            >
              {size}
            </div>
          ))}
        </div>
        <p style={{ color: 'white' }}>$150.00</p>
        {/* Disabled "Buy" button (SOLD OUT) */}
        <button disabled style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#e87c24',
          color: 'white',
          cursor: 'not-allowed',
          display: 'inline-block',
          borderRadius: '5px'
        }}>
          SOLD OUT
        </button>
      </div>
      <div className="boxed2">
        <p style={{ color: 'white' }}>
          HEAVY 14OZ FLEECE<br />
          LOOSE FIT
        </p>
      </div>
    </div>
  );
}

export default App;